import * as React from 'react';
import { Button, ArticleHeading2 } from '@cian/ui-kit';

import * as css from './AeroPhotoTourEntry.css';
import { IPlaceholderImage } from '../../types/aeroPhoto';
import { Layout } from '../Layout';

interface IAeroPhotoTourEntryProps {
  background: IPlaceholderImage | null;
  onClick?(event: React.MouseEvent<HTMLDivElement>): void;
}

export const AeroPhotoTourEntry: React.FC<IAeroPhotoTourEntryProps> = ({ background, onClick }) => {
  return (
    <Layout>
      <div className={css['container']} onClick={onClick} role="button">
        <div className={css['background']}>
          {background && (
            <img
              className={css['background-image']}
              src={background.src}
              srcSet={`${background.src} 1x, ${background.src2x} 2x`}
              alt=""
            />
          )}
        </div>
        <div className={css['content']}>
          <span className={css['look-at-icon']} />
          <div className={css['title']}>
            <ArticleHeading2 color="text-inverted-default" as="h3">
              Виды вокруг жилого комплекса — панорамная съемка
            </ArticleHeading2>
          </div>
          <Button theme="fill_white_secondary">Смотреть</Button>
        </div>
      </div>
    </Layout>
  );
};
